<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card color="#5F6368">
          <v-card-text class="text-xs-center">

            <v-btn v-if="connections.length < 1" @click="connect" color="info">Connect with google ads account</v-btn>

            <v-alert
              v-else
              :value="true"
              color="success"
              icon="link"
            >
              Connected with Google
            </v-alert>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { fetchConnections } from '@/api'

export default {
  name: 'connections',
  components: {
  },
  data () {
    return {
      connections: []
    }
  },

  computed: {

    accountId () {
      return this.$route.params.accountId
    }

  },

  mounted () {
    fetchConnections(this.accountId).then(data => {
      this.connections = data
    })
  },

  methods: {

    connect () {
      const params = {
        state: JSON.stringify({ accountId: this.accountId, xsrf: 'random' }),
        scope: 'https://www.googleapis.com/auth/adwords',
        redirect_uri: 'http://squiddy.io/connect/google-ads',
        client_id: '864815199648-784bihfaoff6hhfiu0u3naim6f53csh4.apps.googleusercontent.com',
        response_type: 'code',
        access_type: 'offline',
        approval_prompt: 'force'
      }
      const querystring = Object.keys(params).reduce(function(a,k){a.push(k+'='+encodeURIComponent(params[k]));return a},[]).join('&')
      const url = 'https://accounts.google.com/o/oauth2/auth?' + querystring
      window.location.href = url
    }

  }
}
</script>
